import { cn } from '@/lib/utils';

export function Divider({
  className,
  orientation = 'horizontal',
}: {
  className?: string;
  orientation?: 'horizontal' | 'vertical';
}) {
  return (
    <div
      className={cn(
        'bg-white/[0.10]',
        orientation === 'horizontal'
          ? 'w-full h-[0.125rem] my-[2.5rem]'
          : 'w-[0.125rem] self-stretch mx-[2.5rem] min-h-[20rem]',
        className
      )}
    />
  );
}
